import { ArrowUpRight, Mail, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "@/components/site/Logo";
import { CTABanner } from "@/components/site/CTACheckpoints";

// Brand icons (inline SVG for authentic brand visuals + colors)
const InstagramIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.336 3.608 1.311.975.975 1.249 2.242 1.311 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.069 4.85c-.062 1.366-.336 2.633-1.311 3.608-.975.975-2.242 1.249-3.608 1.311-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.069c-1.366-.062-2.633-.336-3.608-1.311-.975-.975-1.249-2.242-1.311-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.336-2.633 1.311-3.608.975-.975 2.242-1.249 3.608-1.311C8.416 2.175 8.796 2.163 12 2.163zm0 1.838c-3.155 0-3.508.012-4.745.068-.954.044-1.504.207-1.856.344-.466.181-.8.397-1.15.748-.351.351-.567.684-.748 1.15-.137.352-.3.902-.344 1.856-.056 1.237-.068 1.59-.068 4.745s.012 3.508.068 4.745c.044.954.207 1.504.344 1.856.181.466.397.8.748 1.15.351.351.684.567 1.15.748.352.137.902.3 1.856.344 1.237.056 1.59.068 4.745.068s3.508-.012 4.745-.068c.954-.044 1.504-.207 1.856-.344.466-.181.8-.397 1.15-.748.351-.351.567-.684.748-1.15.137-.352.3-.902.344-1.856.056-1.237.068-1.59.068-4.745s-.012-3.508-.068-4.745c-.044-.954-.207-1.504-.344-1.856-.181-.466-.397-.8-.748-1.15-.351-.351-.684-.567-1.15-.748-.352-.137-.902-.3-1.856-.344-1.237-.056-1.59-.068-4.745-.068zm0 3.135a4.864 4.864 0 110 9.728 4.864 4.864 0 010-9.728zm0 1.838a3.026 3.026 0 100 6.052 3.026 3.026 0 000-6.052zm5.034-2.156a1.137 1.137 0 11-2.273 0 1.137 1.137 0 012.273 0z" />
  </svg>
);

const LinkedinIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.063 2.063 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
  </svg>
);

const WhatsappIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    width="16"
    height="16"
    fill="currentColor"
    {...props}
  >
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
  </svg>
);

const SOCIAL_LINKS = [
  {
    Icon: Mail,
    label: "Email",
    href: "mailto:contact@numedia.be",
    tid: "footer-social-email",
    // Aurora gradient — cohérent avec la charte du site
    style: {
      background: "linear-gradient(135deg, #6366F1 0%, #A855F7 50%, #EC4899 100%)",
    },
  },
  {
    Icon: InstagramIcon,
    label: "Instagram",
    href: "https://www.instagram.com/numedia.studio",
    tid: "footer-social-instagram",
    target: "_blank",
    rel: "noopener noreferrer",
    // Instagram brand gradient (jaune → orange → rose → violet)
    style: {
      background:
        "linear-gradient(45deg, #F09433 0%, #E6683C 25%, #DC2743 50%, #CC2366 75%, #BC1888 100%)",
    },
  },
  {
    Icon: LinkedinIcon,
    label: "LinkedIn",
    href: "https://www.linkedin.com/in/david-devos-7695021a9",
    tid: "footer-social-linkedin",
    target: "_blank",
    rel: "noopener noreferrer",
    // LinkedIn brand blue
    style: { backgroundColor: "#0A66C2" },
  },
  {
    Icon: WhatsappIcon,
    label: "WhatsApp",
    href: "https://wa.me/32498979847",
    tid: "footer-social-whatsapp",
    target: "_blank",
    rel: "noopener noreferrer",
    // WhatsApp brand green
    style: { backgroundColor: "#25D366" },
  },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <>
      {/* Standalone CTA banner — utilise le template partagé "Carnet ouvert" */}
      <CTABanner
        testId="footer-cta-banner"
        eyebrowText="Disponible · Nouveaux projets"
        titleStart="Votre site,"
        titleAccent="ce mois-ci."
        subText="Un café virtuel · Devis clair · Réponse sous 24 h · 0 engagement."
      >
        <a
          href="#reservation"
          data-testid="footer-cta"
          className="inline-flex items-center justify-center gap-2 btn-aurora text-white font-semibold px-7 h-14 rounded-full shadow-tactile-lg hover-lift transition text-base whitespace-nowrap"
        >
          Réserver un appel
          <ArrowUpRight size={16} />
        </a>
        <a
          href="mailto:contact@numedia.be"
          data-testid="footer-cta-email"
          className="btn-outline-aurora inline-flex items-center justify-center gap-2 text-white border border-white/30 font-medium px-6 h-14 rounded-full text-sm whitespace-nowrap"
        >
          <Mail size={15} />
          contact@numedia.be
        </a>
        <a
          href="https://wa.me/32498979847"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-cta-whatsapp"
          className="btn-outline-aurora inline-flex items-center justify-center gap-2 text-white border border-white/30 font-medium px-6 h-14 rounded-full text-sm whitespace-nowrap"
        >
          <MessageCircle size={15} />
          WhatsApp
        </a>
      </CTABanner>

      {/* Footer proper */}
      <footer
        data-testid="site-footer"
        className="dark-aurora-radial text-white relative overflow-hidden paper"
      >
        <div className="mx-auto max-w-7xl px-6 md:px-10 py-14 md:py-20">
          <div className="grid grid-cols-12 gap-x-6 gap-y-10 md:gap-10">
            <div className="col-span-12 md:col-span-5">
              <div className="flex items-center gap-3 mb-3">
                <Logo size={48} variant="dark" />
                <div className="flex flex-col leading-none">
                  <span className="font-brand text-3xl md:text-4xl text-white font-medium tracking-tight uppercase">
                    Numedia
                  </span>
                  <span className="text-[10px] uppercase tracking-[0.22em] text-aurora font-bold mt-1.5">
                    Par David Devos
                  </span>
                </div>
              </div>
              <p className="font-display italic text-aurora text-lg md:text-xl leading-snug mb-6 max-w-sm">
                Donnez à votre activité la visibilité qu'elle mérite.
              </p>
              <p className="text-white/70 leading-relaxed max-w-sm">
                Studio indépendant fondé par David Devos, basé à Bruxelles.
                Création d'identités numériques pour artisans, indépendants et
                petites entreprises.
              </p>

              <div className="mt-8 flex items-center gap-3">
                {SOCIAL_LINKS.map(({ Icon, label, href, tid, style, target, rel }) => (
                  <a
                    key={label}
                    href={href}
                    target={target}
                    rel={rel}
                    aria-label={label}
                    data-testid={tid}
                    style={style}
                    className="h-10 w-10 rounded-full flex items-center justify-center text-white shadow-tactile hover-lift transition-transform duration-300 hover:scale-110"
                  >
                    <Icon size={16} />
                  </a>
                ))}
              </div>
            </div>

            <div className="col-span-6 md:col-span-3 md:col-start-7 min-w-0">
              <div className="eyebrow !text-aurora mb-5">Navigation</div>
              <ul className="space-y-3 text-sm text-white/80">
                <li>
                  <a href="#services" className="hover:text-[#C4B5FD] transition-colors">Services</a>
                </li>
                <li>
                  <a href="#realisations" className="hover:text-[#C4B5FD] transition-colors">Réalisations</a>
                </li>
                <li>
                  <a href="#methode" className="hover:text-[#C4B5FD] transition-colors">Méthode</a>
                </li>
                <li>
                  <a href="#a-propos" className="hover:text-[#C4B5FD] transition-colors">À propos</a>
                </li>
                <li>
                  <a href="#faq" className="hover:text-[#C4B5FD] transition-colors">FAQ</a>
                </li>
              </ul>
            </div>

            <div className="col-span-6 md:col-span-3 md:col-start-10 min-w-0">
              <div className="eyebrow !text-aurora mb-5">Contact</div>
              <ul className="space-y-3 text-sm text-white/80">
                <li>
                  <a
                    href="mailto:contact@numedia.be"
                    data-testid="footer-email"
                    className="hover:text-[#C4B5FD] transition-colors break-words"
                  >
                    contact@numedia.be
                  </a>
                </li>
                <li>
                  <a
                    href="tel:+32498979847"
                    data-testid="footer-phone"
                    className="hover:text-[#C4B5FD] transition-colors"
                  >
                    +32 498 97 98 47
                  </a>
                </li>
                <li className="text-white/60 break-words">Bruxelles · Belgique</li>
                <li className="text-white/60 break-words">À distance, partout en Europe</li>
              </ul>
            </div>
          </div>

          {/* Bottom */}
          <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/60">
            <div>© {year} Numedia · Par David Devos — Tous droits réservés.</div>
            <div className="flex gap-6">
              <Link
                to="/mentions-legales"
                data-testid="footer-link-mentions"
                className="hover:text-white transition-colors"
              >
                Mentions légales
              </Link>
              <Link
                to="/confidentialite"
                data-testid="footer-link-confidentialite"
                className="hover:text-white transition-colors"
              >
                Confidentialité
              </Link>
              <a
                href="mailto:contact@numedia.be"
                data-testid="footer-link-contact"
                className="hover:text-white transition-colors"
              >
                Contact
              </a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
